export default function header() {
	document.addEventListener('DOMContentLoaded', function () {
		const dropdownToggles = document.querySelectorAll('.desktop-menu .dropdown-toggle');
		function toggleSubNav(e) {
			e.preventDefault();
			const subNavWrapper = this.nextElementSibling;
			const mainMenu = document.getElementById('menu-main-menu');
			if (!subNavWrapper.classList.contains('active-primary-nav')) {
				const activeNavWrappers = document.querySelectorAll('.sub-nav-wrapper.active-primary-nav');
				activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('active-primary-nav'));
			}
			if (!this.classList.contains('open')) {
				const activeNavWrappers = document.querySelectorAll('.desktop-menu .dropdown-toggle.open');
				activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
				if (mainMenu) {
					mainMenu.classList.add('active-wrapper-list');
				}
			} else {
				const navspacer = document.querySelector('.navspacer');
				if (navspacer) {
					document.querySelector('.navspacer').style.width = '0px';
				}
				if (mainMenu) {
					mainMenu.classList.remove('active-wrapper-list');
				}
			}
			subNavWrapper.classList.toggle('active-primary-nav');
			if (subNavWrapper.classList.contains('active-primary-nav')) {
				const allMenu = document.querySelectorAll('.nested-list');
				if (allMenu?.length > 0) {
					allMenu.forEach(item => {
						item.classList.remove('show');
					});
				}

				const menu = document.querySelectorAll('.active-primary-nav .nested-list');
				const menuItems = document.querySelectorAll('.active-primary-nav .nested-list li');
				menu.forEach(menuItem => {
					menuItem.classList.toggle('show');
					if (menuItem.classList.contains('show')) {
						menuItems.forEach((item, index) => {
							setTimeout(() => {
								item.classList.add('show');
							}, index * 5); // Adjust the delay as needed
						});
					} else {
						menuItems.forEach(item => {
							item.classList.remove('show');
						});
					}
				});
			}
			this.classList.toggle('open');

			// Add and remove class on body for scroll.
			const activeMenus = document.querySelectorAll('.desktop-menu .dropdown-toggle');
			let ifOpen = false;
			activeMenus.forEach(function (menuItems) {
				if (menuItems.classList.contains('open')) {
					ifOpen = true;
				}
			});
			if (ifOpen === false) {
				document.body.classList.remove('scroll-fix');
			} else {
				document.body.classList.add('scroll-fix');
			}
		}
		dropdownToggles.forEach(toggle => {
			toggle.addEventListener('click', toggleSubNav);
		});

		// Outside UL click to close all sub menu
		window.addEventListener('click', function (e) {
			if (document.getElementById('menu-main-menu')) {
				if (!document.getElementById('menu-main-menu').contains(e.target)) {
					const otherUls = document.querySelectorAll('ul.sub-nav-wrapper.active-primary-nav');
					otherUls.forEach(function (otherItems) {
						if (otherItems.classList.contains('active-primary-nav')) {
							otherItems.classList.remove('active-primary-nav');
							document.body.classList.remove('scroll-fix');
						}
					});
					const otherDropdowns = document.querySelectorAll('.desktop-menu .dropdown-toggle.open');
					otherDropdowns.forEach(function (other) {
						if (other.classList.contains('open')) {
							other.classList.remove('open');
							document.body.classList.remove('scroll-fix');
						}
					});
				}
			}
		});
		// Click on the close icon event
		const closeElements = document.querySelectorAll('.close-wrapper');
		const mainMenu = document.getElementById('menu-main-menu');
		closeElements.forEach(function (item) {
			item.addEventListener('click', function (event) {
				event.preventDefault();
				this.parentElement.parentElement.classList.remove('active-primary-nav');
				const toggleMenuNew = document.getElementById('toggleMenuNew');
				if (toggleMenuNew) {
					toggleMenuNew.classList.remove('open');
				}
				document.body.classList.remove('scroll-fix');
				const navspacer = document.querySelector('.navspacer');
				if (navspacer) {
					document.querySelector('.navspacer').style.width = '0px';
				}
				if (mainMenu) {
					mainMenu.classList.remove('active-wrapper-list');
				}
			});
		});

		// Mobile menu toggle.
		const mobileHamburgerIcon = document.querySelector('#mobile-hamberger-icon');
		const navbarList = document.querySelector('.navbar-list.mobile-menu');
		function toggleMobileMenu(e) {
			e.preventDefault();
			navbarList.classList.toggle('active-hamberger');
			this.classList.toggle('menu-hamberger-open');
			document.body.classList.remove('scroll-fix');
			const activeMobileNavWrappers = document.querySelectorAll('.mobile-dropdown-menu.open');
			activeMobileNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
			const activeNavWrappers = document.querySelectorAll('.mobile-menu .dropdown-toggle.open');
			activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
		}
		if (document.getElementById('mobile-hamberger-icon')) {
			mobileHamburgerIcon.addEventListener('click', toggleMobileMenu);
		}

		// Mobile menu toggle for inside elements.
		const dropdownMobileToggles = document.querySelectorAll('.mobile-menu .dropdown-toggle');
		function toggleMobileSubNav(e) {
			e.preventDefault();
			const subNavMobileWrapper = this.nextElementSibling;
			if (!subNavMobileWrapper.classList.contains('open')) {
				const activeMobileNavWrappers = document.querySelectorAll('.mobile-dropdown-menu.open');
				activeMobileNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
			}
			if (!this.classList.contains('open')) {
				const activeNavWrappers = document.querySelectorAll('.mobile-menu .dropdown-toggle.open');
				activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
			}
			this.classList.toggle('open');
			subNavMobileWrapper.classList.toggle('open');

			// Add and remove class on body for scroll.
			const activeMenus = document.querySelectorAll('.mobile-menu .dropdown-toggle');
			let ifOpen = false;
			activeMenus.forEach(function (menuItems) {
				console.log(menuItems.classList);
				if (menuItems.classList.contains('open')) {
					ifOpen = true;
				}
			});
			if (ifOpen === false) {
				document.body.classList.remove('scroll-fix');
			} else {
				document.body.classList.add('scroll-fix');
			}
		}
		dropdownMobileToggles.forEach(toggle => {
			toggle.addEventListener('click', toggleMobileSubNav);
		});

		// Footer Mobile menu toggle for inside elements.
		const footerToggles = document.querySelectorAll('.footer-heading');

		function toggleMobileNav(e) {
			e.preventDefault();
			const subNavWrapper = this.nextElementSibling;
			if (!subNavWrapper.classList.contains('open')) {
				const activeNavWrappers = document.querySelectorAll('.footer-links.open');
				activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open'));
			}
			if (!this.classList.contains('open-footer')) {
				const activeNavWrappers = document.querySelectorAll('.footer-heading.open-footer');
				activeNavWrappers.forEach(navWrapper => navWrapper.classList.remove('open-footer'));
			}
			subNavWrapper.classList.toggle('open');
			this.classList.toggle('open-footer');
		}

		footerToggles.forEach(toggle => {
			toggle.addEventListener('click', toggleMobileNav);
		});

		const navbarItemLinks = document.querySelectorAll('.navbar-item .dropdown-item');
		navbarItemLinks.forEach(link => {
			link.addEventListener('click', () => {
				const navspacer = document.querySelector('.navspacer');
				if (navspacer) {
					document.querySelector('.navspacer').style.width = '0px';
				}
			});
		});
	});
}
